module.exports = __webpack_public_path__ + "svg/flags/Congo, The Democratic Republic of the.svg";